import { useDispatch, useSelector } from 'react-redux'
import ConfirmModal from '../../../components/ConfirmModalV2'
import usePrinter from '../../../VNPrinters/hooks/usePrinter'
import { setBackBarFinalizeModals } from '../../ActionCreators'
import { getOrderPayments } from '../../../selectors/order'
import { useMemo } from 'react'

export const VNBackBarMissingPaymentModal = () => {
  const dispatch = useDispatch()
  const { printSlipHandler } = usePrinter()
  const orderPayments = useSelector(getOrderPayments)
  const hasPayment = useMemo(() => orderPayments.length > 0, [orderPayments])

  if (hasPayment) {
    return null
  }

  return (
    <ConfirmModal
      onButtonOneClick={() => dispatch(setBackBarFinalizeModals(false))}
      onButtonTwoClick={() => {
        dispatch(setBackBarFinalizeModals(false))
        printSlipHandler()
      }}
      headerText="Missing Payment Method"
      subtext="Please print slip to choose payment method before proceeding."
      buttonOneText="CANCEL"
      buttonTwoText="PRINT SLIP"
      opaque={true}
    />
  )
}
